import React from 'react';
import PageTitle from '../../Components/Dashboard/PageTitle';
import ConfirmationForm from './ConfirmationForm';
import propTypes from 'prop-types';

const DeleteConfirmationForm = ({
                                  onClose,
                                  step,
                                  validationCodeSuccess,
                                  beneficiaryName,
                                  onConfirmDeletion,
                                  navigationSteps
                                }) => {
  return (

      <div className="template-scroll profile-container">
        <PageTitle titleText="Supprimer un bénéficiaire" canGoBack={false} />

        <div className="full-container">

          <ConfirmationForm
            onClose={onClose}
            validationCodeSuccess={validationCodeSuccess}
            beneficiaryName={beneficiaryName}
            onConfirmDeletion={onConfirmDeletion}
            navigationSteps={navigationSteps}
          />

        </div>
      </div>

  );
};
DeleteConfirmationForm.propTypes = {
  step: propTypes.number,
  onClose: propTypes.func.isRequired,
  validationCodeSuccess: propTypes.bool.isRequired,
  beneficiaryName: propTypes.string.isRequired,
  onConfirmDeletion: propTypes.func.isRequired,
  navigationSteps: propTypes.any
};

export default DeleteConfirmationForm;
